export default "__VITE_ASSET__BV6Ji1GL__"